// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8TAlC","question":"styles_question__17Kyl","description":"styles_description__1P3Eq"};